function parseUri(uri) {
  try {
    return new URL(uri)
  } catch (_) {
    return null
  }
}

export default parseUri
